/** Normalize a piece of track metadata for case/whitespace-insensitive comparison. */
export const normalizeTrackText = (value: string): string =>
  value.trim().toLowerCase().replace(/\s+/g, ' ');

/** A stable, comparison-friendly key for a track's title+artist pair. */
export const normalizeTrackKey = (title: string, artist: string): string =>
  `${normalizeTrackText(title)}|${normalizeTrackText(artist)}`;
